import script from "./ExePricing.vue?vue&type=script&setup=true&lang=js"
export * from "./ExePricing.vue?vue&type=script&setup=true&lang=js"

import "./ExePricing.vue?vue&type=style&index=0&id=0a62fcb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a62fcb7"]])

export default __exports__